export default __webpack_public_path__ + "static/media/29_2_0.58dc0184.png";